<template>
  <section class="text-gray-600 body-font">
      
    <div class="container px-5 py-24 mx-auto">
     <div class="flex flex-col text-center w-full mb-20">

      <h1 class="sm:text-3xl text-3xl font-bold title-font mb-2 text-gray-900">More than 10 users trust trackee</h1>

    
     </div>
      <div class="flex flex-wrap -m-4 text-center">
        <div class="p-4 sm:w-1/4 w-1/2">
          <h2 class="title-font font-medium sm:text-4xl text-3xl text-gray-900">
           7
          </h2>
          <p class="leading-relaxed">Active Users</p>
        </div>
        <div class="p-4 sm:w-1/4 w-1/2">
          <h2 class="title-font font-medium sm:text-4xl text-3xl text-gray-900">
            10
          </h2>
          <p class="leading-relaxed">Subscribes</p>
        </div>
        <div class="p-4 sm:w-1/4 w-1/2">
          <h2 class="title-font font-medium sm:text-4xl text-3xl text-gray-900">
            2

          </h2>
          <p class="leading-relaxed">Reports</p>
        </div>
        <div class="p-4 sm:w-1/4 w-1/2">
          <h2 class="title-font font-medium sm:text-4xl text-3xl text-gray-900">
            5

          </h2>
          <p class="leading-relaxed">Projects Completed</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "Report",
};
</script>
